const atgProductContent = {
  productFeatureSpecs: {
    features: 'Caractéristiques',
    specifications: 'Spécifications',
    readMore: 'Lire plus',
    readLess: 'Lire moins',
  },
};

export const atgProduct = {
  ...atgProductContent,
  atgProduct: atgProductContent,
};
